import Cookies from "js-cookie";

class CookiesService {
    add(key: string, value: any, ttl?: number) {
        //$.jStorage.set(key, value, {TTL: ttl || 0});
        if (ttl) {
            Cookies.set(key, value, {expires: ttl});
        } else {
            Cookies.set(key, value);
        }
    }

    get(key: string) {
        //return $.jStorage.get(key);
        return Cookies.get(key);
    }

    remove(key: string) {
        //$.jStorage.deleteKey(key);
        Cookies.remove(key);
    }
}

export default new CookiesService();
